import { ForgotPasswordForm } from "@/components/formik/auth/ForgotPasswordForm.tsx";
import AuthLayout from "@/components/layouts/AuthLayout";


export const ForgotPasswordView = () => {
  return (
    <div>
      <AuthLayout
        title="Forgot Password?"
        subtitle="Enter your email so we can send you a password reset link"
      >
        <ForgotPasswordForm />
      </AuthLayout>
    </div>
  );
};
